module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1A0yq1r/tc-custom/9781453231920.jpg?1728353338805",
      "alt": "This image is the cover for the book Emotions"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Emotions\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("One of the leading twentieth-century French existentialist philosophers examines how human emotions shape our existence.")]), _c('br'), _c('br'), _vm._v(" In "), _c('i', [_vm._v("The Emotions: Outline of a Theory")]), _vm._v(", French philosopher Jean-Paul Sartre attempts to understand the role emotions play in the human psyche. Sartre analyzes fear, lust, anguish, and melancholy while asserting that human beings begin to develop emotional capabilities from a very early age, which helps them identify and understand the emotions’ names and qualities later in life."), _c('br'), _vm._v(" Helping to complete the circle of Sartre’s many theories on existentialism, this vital piece of literature is a must-have for the philosopher-in-training’s collection.  \n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jean-Paul Sartre, Bernard Frechtman\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Jean-Paul Sartre (1905–1980) was a significant voice in the creation of existential thought. His explorations of the ways human existence is unique among all life-forms in its capacity to choose continue to influence fields such as Marxist philosophy, sociology, and literary studies. He was awarded the 1964 Nobel Prize in Literature, but refused the honor.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Integrated Media\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0